import React from "react";
//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />
import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path
import { NavLink } from "react-router-dom";

function Create() {
  AnimationFileLoader();

  return (
    <>


      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}

      {/* Create Collectible */}
      <section className="pt-120 pb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              {/* Section Title */}
              <div className="section-title text-center text-white">
                <h2>Create Collectible</h2>
                <p>
                  Choose "Single" if you want your collectibles to be one of
                  NavLink kinds or "Multiple" if you want to sell by ones
                  collectibles Upload your work likes Image, video, audio times
                  for Anefty.
                </p>
              </div>
              {/* End Section Title */}
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-3 col-lg-4 col-md-5 col-sm-6">
              {/* Single Create */}
              <div className="create-box">
                <NavLink to="/explore/create/upload">
                  <img src="/img/media/single-upload.png" alt="" />
                  <h3>Single</h3>
                </NavLink>
              </div>
              {/* End Single Create */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-5 col-sm-6">
              {/* Multiple Create */}
              <div className="create-box">
                <NavLink to="/explore/create/upload">
                  <img src="/img/media/multiple-upload.png" alt="" />
                  <h3>Multiple</h3>
                </NavLink>
              </div>
              {/* End Multiple Create */}
            </div>
          </div>
        </div>
      </section>
      {/* End Create Collectible */}
    
    </>
  );
}

export default Create;
